// GENERATED FILE - DO NOT MODIFY

export enum ManagementRoleNameDto {
    Administrator = "Administrator",
    BuildingManager = "BuildingManager",
}